import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {tabsDefaultContent} from './tabsSectionDefaultContent';
import {componentsHelper} from "../../helpers/componentsHelper";
import l10n from "../../../lang/locallang";

const tabsSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(tabsDefaultContent);
    const { tabsTexts } = l10n;
    param.class = param.class ? param.class : 'tabs-section editor-section';
    param.style = param.style ? param.style : '';
    param.section = 'tabsSection';

    let defaultContentValue = {
        0: {
            id: '',
            title: tabsTexts[0].title,
            text: `<p>${tabsTexts[0].text}</p>`,
            order: 1,
        },
        1: {
            id: '',
            title: tabsTexts[1].title,
            text: `<p>${tabsTexts[1].text}</p>`,
            order: 2,
        },
        2: {
            id: '',
            title: tabsTexts[2].title,
            text: `<p>${tabsTexts[2].text}</p>`,
            order: 3,
        },
    }

    const { enterTitle } = l10n.editor;
    let tabsList = param.content && param.content.tabs ? Object.values(param.content.tabs) : defaultContentValue;
    let content = '';
    content += `<div class="tabs-header-wrapper">`;
    content += `<div class="tabs-header">`;
    let idx = 0;
    for (let key in tabsList) {
        if (tabsList.hasOwnProperty(key)) {
            let item = tabsList[key];
            content += `<div class="tab-header ${idx === 0 ?  `active` : ``}" data-tab="${item.order}">
                            <span ${!is_public ? `class="editable-text" contenteditable="true" data-placeholder="${enterTitle}"` : ''}>${item.title}</span>
                            ${!is_public ? `
                            <button class="btn tab-button-delete"><i class="icon icon-trash"></i></button>
                            ` : '' }
                        </div>`;
            idx++;
        }
    }
    content += !is_public ? `<div class="tab-header-new"><button class="add-new-tab"><i class="icon icon-add"></i></button></div></div></div>` : `</div></div>`;
    content += `<div class="tabs-list">`;
    let idxx = 0;
    for (let key in tabsList) {
        if (tabsList.hasOwnProperty(key)) {
            let item = tabsList[key];
            content += `
                <div class="tab-item ${idxx === 0 ?  `active` : ``}" data-tab="${item.order}" data-order="${item.order}">
                    <div class="text-content fr-editor-tabs">
                        ${item.text ? item.text : ''}
                    </div>
                </div>`;
            idxx++;
        }
    }
    content += `</div>`;

    param.component = `
        <div class="tabs-box __first">
            ${content}
        </div>
    `;

    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}


export {tabsSection};
